import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  successToastTitle: {
    defaultMessage: 'Success',
    id: 'pymiNS',
    description: 'Title of a toast message to tell the user their store was setup successfully.',
  },
  successToastDescription: {
    defaultMessage: 'Successfully added {storeName}.',
    id: 'D42g6l',
    description: 'Description of a toast message to tell the user their store was setup successfully.',
  },
  errorToastTitle: {
    defaultMessage: 'Error',
    id: 'yZqTqT',
    description: 'Title of a toast message to tell the user their store errored out during setup.',
  },
  errorToastDescription: {
    defaultMessage: '{storeName} was not added successfully. Please try again.',
    id: 'TES8/d',
    description: 'Description of a toast message to tell the user their store errored out during setup.',
  },
});
